export default __webpack_public_path__ + "static/superglue-408e39b61b3ff1e63ab7cd9c1be43501.png";